// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ju4Rz","label":"styles_label__1_1ja"};